import { WhatsAppNotificationService } from "@boi/shared-services";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { CreateQuestion } from "../create-questions/entities/create-question";
import { TabQuestionRepo } from "../create-questions/repos/tab-question.repo";
import { Chapter } from "../entities/chapter";
import { ClassEntity } from "../entities/class";
import { Complexity } from "../entities/complexity";
import { LanguageEntity } from "../entities/language";
import { QuestionType } from "../entities/question-type";
import { Subject } from "../entities/subject";
import { Topic } from "../entities/topic";
import { Ability } from "../entities/abilities";
import { AbilityType } from "../entities/ability-types";
import { QuestionTypeMaster } from "../entities/question-type-master";
import { CompetencyCode } from "../entities/competency-code";
import { QuestionPaperModal } from "../model-paper/entities/question-paper-modal";
import { ModelPaperRepo } from "../model-paper/repositories/model-paper-repo";
import { AIGeneratedQPController } from "./ai-generated-qp.controller";
import { AiGeneratedQpService } from "./ai-generated-qp.service";
import { SectionQuestionsMappingAdapter } from "./dtos/section-questions-mapping.adaptr";
import { PaperMergeChildEntity } from "./entities/paper-merge-child.entity";
import { PaperMergeEntity } from "./entities/paper-merge.entity";
import { QuestionPapers } from "./entities/question-papers";
import { SectionQuestionMappingEntity } from "./entities/section-question-mapping.entity";
import { UserToQnosMappingEntity } from "./entities/user-to-qnos-mapping.entity";
import { ChapterRepo } from "./repo/chapter-repo";
import { ClassRepo } from "./repo/class-repo";
import { ComplexityRepo } from "./repo/complexity-repo";
import { CreateQuestionRepo } from "./repo/create-question-repo";
import { LanguagesRepo } from "./repo/languages-repo";
import { PaperMergeChildRepo } from "./repo/paper-merge-child.repo";
import { PaperMergeRepo } from "./repo/paper-merge.repo";
import { QuestionPapersRepo } from "./repo/question-papers-repo";
import { QuestionTypeRepo } from "./repo/question-type-repo";
import { SectionQuestionMappingRepo } from "./repo/section-question-mapping-repo";
import { SectionWiseModelRepo } from "./repo/section-wise-model-repo";
import { SubjectRepo } from "./repo/subject-repo";
import { TopicRepo } from "./repo/topic-repo";
import { AbilityRepo } from "./repo/ability-repo";
import { AbilityTypeRepo } from "./repo/ability-type-repo";
import { QuestionTypeMasterRepo } from "./repo/question-type-master-repo";
import { CompetencyCodeRepo } from "./repo/competency-code-repo";
import { TabQuestion } from "../create-questions/entities/tab-question.entity";
import { DepartmentRepo } from "./repo/department-repo";
import { Department } from "../entities/department-entity";
@Module({
    imports: [TypeOrmModule.forFeature([ClassEntity, Chapter, Complexity, QuestionType, Subject, Topic, Complexity, QuestionType, LanguageEntity, CreateQuestion, QuestionPaperModal, QuestionPapers, SectionQuestionMappingEntity, UserToQnosMappingEntity, PaperMergeEntity, PaperMergeChildEntity, TabQuestion, Ability, AbilityType, QuestionTypeMaster, CompetencyCode, Department])],
    controllers: [AIGeneratedQPController],
    providers: [AiGeneratedQpService, SectionQuestionsMappingAdapter, ClassRepo, ChapterRepo, ComplexityRepo, QuestionTypeRepo, SubjectRepo, TopicRepo, ComplexityRepo, QuestionTypeRepo, CreateQuestionRepo, QuestionPapersRepo, SectionQuestionMappingRepo, LanguagesRepo, ModelPaperRepo, SectionWiseModelRepo, WhatsAppNotificationService, TabQuestionRepo, PaperMergeRepo, PaperMergeChildRepo, AbilityRepo, AbilityTypeRepo, QuestionTypeMasterRepo, CompetencyCodeRepo, DepartmentRepo],
    exports: [AiGeneratedQpService]
})

export class AIGeneratedQpModule { }